export const TokenType = Object.freeze({
  EOF: -1,
  DateTimeToken: "DateTime",
	FailToken: "Fail",
	LoadToken: "Load",
	MetaKeyToken: "Meta Key",
	MetaValueToken: "Meta Value",
	MovementToken: "Movement",
	NoteToken: "Note",
	RepToken: "Rep",
	SetToken: "Set",
	SupersetMovementToken: "Superset Movement"
});
